import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ContentGroup } from '@/models/content-group.model';

@Injectable({ providedIn: 'root' })
export class ContentGroupsService {
  private readonly apiUrl = `${environment.landmark_API_URL}/content-groups`;

  groups = signal<ContentGroup[]>([]);
  loading = signal<boolean>(false);

  constructor(private http: HttpClient) {
    this.fetchAll();
  }

  // -------------------------------
  // LOAD ALL GROUPS
  // -------------------------------
  fetchAll() {
    this.loading.set(true);
    this.http.get<ContentGroup[]>(this.apiUrl).subscribe({
      next: (data) => {
        this.groups.set(data);
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Failed to load content groups:', err);
        this.loading.set(false);
      },
    });
  }

  // -------------------------------
  // UPDATE A GROUP (link payloadId)
  // -------------------------------
  updateGroup(cGroupId: number, payloadId: number | null) {
    // Optimistic update
    this.groups.update((list) =>
      list.map((g) => (g.cGroupId === cGroupId ? { ...g, payloadId } : g))
    );

    return this.http.put(`${this.apiUrl}/${cGroupId}`, { payloadId }).subscribe({
      error: (err) => {
        console.error('Failed to update content group:', err);
        // TODO: Revert optimistic UI if needed
      },
    });
  }

  // -------------------------------
  // CREATE NEW GROUP (future feature)
  // -------------------------------
  createGroup(name: string, payloadId?: number | null) {
    return this.http
      .post<ContentGroup>(this.apiUrl, {
        name,
        payloadId: payloadId ?? null,
      })
      .subscribe({
        next: (newGroup) => {
          this.groups.update((list) => [...list, newGroup]);
        },
        error: (err) =>
          console.error('Failed to create content group:', err),
      });
  }
  

  // -------------------------------
  // DELETE GROUP (optional)
  // -------------------------------
  deleteGroup(cGroupId: number) {
    return this.http.delete(`${this.apiUrl}/${cGroupId}`).subscribe({
      next: () => {
        this.groups.update((list) =>
          list.filter((g) => g.cGroupId !== cGroupId)
        );
      },
      error: (err) => console.error('Failed to delete content group:', err),
    });
  }
}
